import { RootState } from "../../../store";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { offHoursPatchFixedCacheKey } from "../../thunks/toggleOffHoursStatusThunk";

export const offHoursUpdateLoadingSelector = (state: RootState): boolean => {
  return cloudChiprApi.endpoints.patchV2UsersMeOffHoursSchedulesByScheduleId.select(
    offHoursPatchFixedCacheKey,
  )(state).isLoading;
};
